import { render, staticRenderFns } from "./signName.vue?vue&type=template&id=f31c96d4&scoped=true"
import script from "./signName.vue?vue&type=script&lang=js"
export * from "./signName.vue?vue&type=script&lang=js"
import style0 from "./signName.vue?vue&type=style&index=0&id=f31c96d4&prod&scoped=true&lang=css"
import style1 from "./signName.vue?vue&type=style&index=1&id=f31c96d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31c96d4",
  null
  
)

export default component.exports